import { http } from "@client/shared/services";
import { responseFormatter } from "@client/utils";


const get = (query = "") => {
  return responseFormatter(
    http.get(`/account/role-access${query}`, {
      setAuthHeader: true,
    })
  );
};

const patch = (id, payload = {}) => {
  return responseFormatter(
    http.patch(`/account/role-access/${id}`, payload, {
      setAuthHeader: true,
    })
  );
};

const Service = {
  get,
  patch,
};

export default Service;
